/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import template from './workspace-view-page.component.html';

import {
  buildWorkspaceGridsterOpts,
  initWorkspaceModel,
  setupWorkspaceWidgetDefaults
} from './workspace-commons';
import {AdnTimeShifterService} from '../../components/util/adn-time-shifter.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-workspace-view-page',
  template
})
export class WorkspaceViewPageComponent implements OnChanges {
  @Input() model: any;

  gridsterOpts = buildWorkspaceGridsterOpts(false);

  constructor(
    private readonly translate: TranslateService,
    @Inject(AdnTimeShifterService) private readonly adnTimeShifter: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnChanges(): void {
    if (!this.model) {
      return;
    }
    initWorkspaceModel(
      this.model,
      this.LocalUserPermissions.hasNetworkPermission('MANAGE_NETWORK_DASHBOARDS'),
      this.LocalNetworkProfile.isPureMarketplacePlatform()
    );
    setupWorkspaceWidgetDefaults(
      this.model.data.widgets,
      (key) => this.translate.instant(key),
      this.LocalNetworkProfile,
      this.adnTimeShifter
    );
  }
}
